import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useEmail from './hooks/email.js'
import { fetchZendeskMessagingJwt } from './zendesk-messaging-jwt.js'

const ZD_GIVEN = '.givenName'

function readZendeskLsNames (email) {
  const want = String(email || '').trim().toLowerCase()
  let fallback = null
  for (const key of Object.keys(window.localStorage)) {
    if (!key.endsWith(ZD_GIVEN)) continue
    const prefix = key.slice(0, -ZD_GIVEN.length)
    const zdEmail = String(window.localStorage.getItem(`${prefix}.email`) || '').trim()
    const givenName = (window.localStorage.getItem(key) || '').trim()
    const familyName = (window.localStorage.getItem(`${prefix}.surname`) || '').trim()
    if (!zdEmail && !givenName && !familyName) continue
    const row = { email: zdEmail, givenName, familyName }
    if (want && zdEmail.toLowerCase() === want) return row
    if (!fallback) fallback = row
  }
  return fallback || { email: '', givenName: '', familyName: '' }
}

function resolveZendeskRoleContext () {
  const host = window.location.hostname
  const firstLabel = host.split('.')[0] || ''
  if (host.includes('.manager.')) return 'manager'
  if (firstLabel === 'manager' || firstLabel.endsWith('-manager')) return 'manager'
  if (host.includes('.renter.')) return 'renter'
  if (firstLabel === 'renter' || firstLabel.endsWith('-renter')) return 'renter'
  return null
}

export default function ZendeskMessagingBoot () {
  const { email } = useEmail()
  const { search } = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(search)
    const emailFromQuery = (searchParams.get('email') || '').trim()
    const zd = readZendeskLsNames(email || emailFromQuery)
    const effectiveEmail = (email || emailFromQuery || zd.email || '').trim()
    if (!effectiveEmail) return

    let givenName = (searchParams.get('givenName') || searchParams.get('firstName') || window.localStorage.getItem('loginFirstName') || zd.givenName || '').trim()
    if (!givenName) {
      const at = effectiveEmail.indexOf('@')
      if (at > 0) givenName = effectiveEmail.slice(0, at)
    }
    if (!givenName) return

    const body = { email: effectiveEmail, givenName }
    const zendeskRoleContext = resolveZendeskRoleContext()
    if (zendeskRoleContext) body.zendeskRoleContext = zendeskRoleContext
    const familyName = (searchParams.get('familyName') || searchParams.get('lastName') || window.localStorage.getItem('loginLastName') || zd.familyName || '').trim()
    if (familyName) body.familyName = familyName

    let cancelled = false
    let pollId
    let loginDelayId

    ;(async () => {
      try {
        const { zendesk } = await fetchZendeskMessagingJwt(body)
        const jwt = zendesk?.jwt
        if (cancelled || !jwt) return

        const login = () => {
          if (cancelled) return
          window.zE?.('messenger', 'loginUser', cb => cb(jwt), () => {})
        }
        const run = () => {
          if (!window.zE) return
          if (loginDelayId) clearTimeout(loginDelayId)
          window.zE(login)
          loginDelayId = setTimeout(login, 500)
        }
        run()
        if (!window.zE) {
          pollId = setInterval(() => {
            if (cancelled || !window.zE) return
            clearInterval(pollId)
            pollId = undefined
            run()
          }, 100)
        }
      } catch (e) {
        console.error('Zendesk auth-ui JWT failed', e)
      }
    })()

    return () => {
      cancelled = true
      if (loginDelayId) clearTimeout(loginDelayId)
      if (pollId) clearInterval(pollId)
    }
  }, [email, search])

  return null
}
